import { AdminSession, SessionStatus } from '@airreading/common/data';
import { ReactNode } from 'react';
import { SessionStatusChangeModal } from './session-status-change-modal';

interface CancelSessionsProps {
  sessions: AdminSession[];
  trigger: ReactNode;
  onSuccess?: () => void;
}

export const CancelSessions = ({ sessions, trigger, onSuccess }: CancelSessionsProps) => {
  const cancelableSessions = sessions.filter((session) => session.status !== SessionStatus.cancelled);

  return (
    <SessionStatusChangeModal
      sessions={cancelableSessions}
      trigger={trigger}
      targetStatus={SessionStatus.cancelled}
      modalTitle="Are you sure to cancel the following sessions?"
      confirmBtnLabel="Cancel sessions"
      description="All student attendance will be canceled and an email will be sent to the teacher notifying the session was canceled."
      noValidSessionsMessage="None of the selected sessions are cancelable. Only scheduled sessions can be cancelled, and already cancelled sessions are excluded."
      invalidSessionsMessage="There are {count} sessions that cannot be cancelled. Only scheduled sessions can be cancelled, and already cancelled sessions are excluded."
      buttonVariant="destructive"
      onSuccess={onSuccess}
    />
  );
};
